import React from 'react';
import PropTypes from 'prop-types';

import RouteBundler from 'components/RouteBundler';
import AuthorizationWrapper from 'components/Auth/AuthorizationWrapper';
import roles from 'core/roles';

import ShortWorkTable from './Table';
import ShortWorkEditor from './Edit';
import ShortWorkNew from './New';

/* eslint-disable prettier/prettier */
const routes = [
  { path: '', component: ShortWorkTable, exact: true },
  // { path: ':id/view', render: props => <ShortWorkEditor {...props} readonly />, exact: true },
  { path: ':id/edit', component: ShortWorkEditor, exact: true },
  { path: 'new', component: ShortWorkNew, exact: true },
];
/* eslint-enable prettier/prettier */

class ShortWork extends React.Component {
  static propTypes = {
    me: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    return (
      <RouteBundler
        prefix={`${this.props.match.path}/`}
        routes={routes}
        me={this.props.me}
      />
    );
  }
}

export default AuthorizationWrapper([roles.ADMIN])(ShortWork);
